import { API_AUTH } from "./common";

const DanhSachLogApi = {
  list: ({
    sUser,
    sNote,
    sStartDate,
    sEndDate,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `QuanLyLog/DanhSach?PageIndex=${pageIndex}&PageSize=${pageSize}&sUser=${sUser}&sNote=${sNote}&sStartDate=${sStartDate}&sEndDate=${sEndDate}`,
      {}
    ),

    
};



export default DanhSachLogApi;
